import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useContactBalance,
  useMultiplePayableSubjects,
  usePaymentModal,
} from '../../../paymentReconciliationModal/contexts'
import { SubjectPaymentAmount } from './elements'
import * as Styled from './styles'

export const SubjectSummary = (): ReactElement => {
  const { t } = useTranslation()

  const { subjectCurrencyId, selectedAccount, isCrossCurrency } = usePaymentModal()
  const { contact } = useContactBalance()
  const { selectedSubjectsAmountsSum, convertedSubjectsAmountsSum } = useMultiplePayableSubjects()

  const vendorName = contact?.name
  const shouldShowPaymentAmount = !!selectedSubjectsAmountsSum && !!subjectCurrencyId
  const contactLabel = contact?.isSupplier ? 'vendor' : 'customer'

  return (
    <Styled.SubjectSummaryWrapper>
      <div>
        <Text variant="bodySM" colorVariant="secondary">
          {t(contactLabel)}
        </Text>
        <Text>{vendorName}</Text>
      </div>
      <SubjectPaymentAmount
        accountCurrencyId={selectedAccount?.currencyId}
        subjectCurrencyId={subjectCurrencyId ?? ''}
        convertedSubjectsAmountsSum={convertedSubjectsAmountsSum}
        selectedSubjectsAmountsSum={selectedSubjectsAmountsSum}
        isCrossCurrency={isCrossCurrency}
        shouldShowPaymentAmount={shouldShowPaymentAmount}
      />
    </Styled.SubjectSummaryWrapper>
  )
}
